import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={`mb-12 lg:mb-16 ${align === "center" ? "text-center" : ""}`}>
    <p className="font-mono text-xs tracking-[0.3em] uppercase text-volt mb-4">{eyebrow}</p>
    <h2 className="font-head text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight leading-none">
      {title}
    </h2>
    {sub && <p className="mt-5 max-w-2xl text-zinc-400 text-base md:text-lg leading-relaxed">{sub}</p>}
  </Reveal>
);
